"use strict";

module.exports = {
  purple1: "#855279",
  purple2: "#BD75AC",
  purple3: "#DBC0D4",
  yellow1: "#AC8E4C",
  yellow2: "#F4C96C",
  yellow3: "#F0DFBC",
  peach1: "#AE6E52",
  peach2: "#F79C75",
  peach3: "#F1CEBF",
  blue1: "#1B6383",
  blue2: "#268CBA",
  blue3: "#A1C8DA",
  teal1: "#127479",
  teal2: "#19A4AB",
  teal3: "#9CD1D4",
  gray1: "#393939",
  gray2: "#828282",
  gray3: "#DCDCDC",
  gray4: "#ECECEC"
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNvbG9ycy5qcyJdLCJuYW1lcyI6WyJtb2R1bGUiLCJleHBvcnRzIiwicHVycGxlMSIsInB1cnBsZTIiLCJwdXJwbGUzIiwieWVsbG93MSIsInllbGxvdzIiLCJ5ZWxsb3czIiwicGVhY2gxIiwicGVhY2gyIiwicGVhY2gzIiwiYmx1ZTEiLCJibHVlMiIsImJsdWUzIiwidGVhbDEiLCJ0ZWFsMiIsInRlYWwzIiwiZ3JheTEiLCJncmF5MiIsImdyYXkzIiwiZ3JheTQiXSwibWFwcGluZ3MiOiI7O0FBQUFBLE1BQUFBLENBQU9DLE9BQVBELEdBQWlCO0FBQ2ZFLEVBQUFBLE9BQUFBLEVBQVksU0FERztBQUNRQyxFQUFBQSxPQUFBQSxFQUFZLFNBRHBCO0FBQytCQyxFQUFBQSxPQUFBQSxFQUFZLFNBRDNDO0FBRWZDLEVBQUFBLE9BQUFBLEVBQVksU0FGRztBQUVRQyxFQUFBQSxPQUFBQSxFQUFZLFNBRnBCO0FBRStCQyxFQUFBQSxPQUFBQSxFQUFZLFNBRjNDO0FBR2ZDLEVBQUFBLE1BQUFBLEVBQVcsU0FISTtBQUdPQyxFQUFBQSxNQUFBQSxFQUFXLFNBSGxCO0FBRzZCQyxFQUFBQSxNQUFBQSxFQUFXLFNBSHhDO0FBSWZDLEVBQUFBLEtBQUFBLEVBQVUsU0FKSztBQUlNQyxFQUFBQSxLQUFBQSxFQUFVLFNBSmhCO0FBSTJCQyxFQUFBQSxLQUFBQSxFQUFVLFNBSnJDO0FBS2ZDLEVBQUFBLEtBQUFBLEVBQVUsU0FMSztBQUtNQyxFQUFBQSxLQUFBQSxFQUFVLFNBTGhCO0FBSzJCQyxFQUFBQSxLQUFBQSxFQUFVLFNBTHJDO0FBTWZDLEVBQUFBLEtBQUFBLEVBQVUsU0FOSztBQU1NQyxFQUFBQSxLQUFBQSxFQUFVLFNBTmhCO0FBTTJCQyxFQUFBQSxLQUFBQSxFQUFVLFNBTnJDO0FBTWdEQyxFQUFBQSxLQUFBQSxFQUFVO0FBTjFELENBQWpCcEIifQ==